/* Support pages use native forms and details. Only viewport state and header-aware anchors need JS. */
(() => {
  'use strict';
  const desktop = matchMedia('(min-width:1000px)');
  const initialize = (root=document) => root.querySelectorAll('[data-es-responsive-footer] .es-footer-group').forEach(group=>{group.open=desktop.matches;});
  initialize(); desktop.addEventListener('change',()=>initialize());
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('click',event=>{
    const link=event.target.closest('.es-guide-jumps a'); if(!link)return;
    const target=document.getElementById(link.hash.slice(1));if(!target)return;
    event.preventDefault();event.stopPropagation();
    const header=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))||100;
    window.scrollTo({top:Math.max(0,window.scrollY+target.getBoundingClientRect().top-header-16),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
  },true);
})();
